/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ amount: NonNullable<unknown> }} Order_Settlement_Collect_FeeInputs */

const vi_order_settlement_collect_fee = /** @type {(inputs: Order_Settlement_Collect_FeeInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Thu cước hộ ${i?.amount}`)
};

/**

* @param {Order_Settlement_Collect_FeeInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const order_settlement_collect_fee = /** @type {((inputs: Order_Settlement_Collect_FeeInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Order_Settlement_Collect_FeeInputs, { locale?: "vi" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_order_settlement_collect_fee(inputs)
});